<div class="cont">
    <H2 class="head">{{'anti-corruption.head'|translate}}</H2>
    <div>
        {{'anti-corruption.text'|translate}}
    </div>
   
</div>
<docs-table [translations]="translations"></docs-table>
